// components/SEOHelmet.js
import { Helmet } from "react-helmet-async";
import metaTags from "../seo/metaTags";

const SEOHelmet = ({ page }) => {
  const meta = metaTags[page];
  //console.log("page", page);
  //console.log("metaTags", meta)

  // Example JSON-LD structured data for a How-To guide
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "HowTo",
    "name": "How to Use TraceMaster",
    "description": "A step-by-step guide to using TraceMaster for analyzing emails.",
    "step": [
      {
        "@type": "HowToStep",
        "name": "Step 1: Enter Email",
        "text": "Go to the TraceMaster page and enter your email in the field."
      },
      {
        "@type": "HowToStep",
        "name": "Step 2: Click Analyze",
        "text": "Click the 'Analyze' button to start the analysis."
      },
      {
        "@type": "HowToStep",
        "name": "Step 3: View Results",
        "text": "See the results, including ISP details and metadata."
      }
    ]
  };

  return (
    <>
      <Helmet>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta property="og:title" content={meta.og.title} />
        <meta property="og:description" content={meta.og.description} />
        <meta property="og:url" content={meta.og.url} />
        {/* Add the JSON-LD structured data */}
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      </Helmet>
    </>
  );
};

export default SEOHelmet;



